import DelegateStructTreeItem from "./DelegateStructTreeItem";

import React, { useMemo } from "react";
import { ClipLoader } from "react-spinners";

function buildTree(flatList) {
    const map = {};
    const roots = [];
    flatList.forEach((node) => {
        map[node.id] = { ...node, children: [] };
    });
    flatList.forEach((node) => {
        if (node.parentId == null) roots.push(map[node.id]);
        else map[node.parentId]?.children.push(map[node.id]);
    });
    return roots;
}

function buildPaths(tree) {
    const paths = {};
    function walk(nodes, parentPath) {
        nodes.forEach((node) => {
            paths[node.id] = [...parentPath, node.id];
            if (node.children.length) walk(node.children, paths[node.id]);
        });
    }
    walk(tree, []);
    return paths;
}

const DelegateStructTreeSelector = (
    {
        structs,
        isLoading,
        loadError,
        onRetry,
        selectedId,
        onSelect,
    },
) => {
    const tree = useMemo(() => buildTree(structs || []), [structs]);
    const paths = useMemo(() => buildPaths(tree), [tree]);

    if (isLoading) {
        return (
            <div className={"delegate-struct-tree__state"}>
                <ClipLoader size={20} color={"#6DCDF6"} />
            </div>
        );
    }

    if (loadError) {
        return (
            <div className={"delegate-struct-tree__state"}>
                <span>Не удалось загрузить список, попробуйте ещё раз</span>
                <button type="button" onClick={onRetry} className={"delegate-struct-tree__state__retry"}>
                    Повторить
                </button>
            </div>
        );
    }

    if (!tree.length) {
        return (
            <div className={"delegate-struct-tree__state"}>Нет подразделений</div>
        );
    }

    return (
        <div className={"delegate-struct-tree"}>
            {
                tree.map((node) => (
                    <DelegateStructTreeItem
                        key={node.id}
                        item={node}
                        selectedId={selectedId}
                        onSelect={onSelect}
                        selectedIdPath={paths[selectedId]}
                    />
                ))
            }
        </div>
    );
};

export default DelegateStructTreeSelector;